import * as microsoftTeams from '@microsoft/teams-js';
import * as React from 'react';

import { v4 as uuidv4 } from 'uuid';
import { AADClientId, URLs } from '../../../models/constants/constants';

/**
 * This component is used to redirect the user to the Azure authorization endpoint from a popup
 */
class ConsentPopup extends React.Component {
  public componentDidMount() {
    // Initialize the Microsoft Teams SDK
    microsoftTeams.initialize();

    const clientId = AADClientId; // Client ID of the Azure AD app registration ( may be from different tenant for multitenant apps)

    // Form a query for the Azure implicit grant authorization flow
    // https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-implicit-grant-flow
    const queryParams = {
      clientId: `${clientId}`,
      responseType: 'id_token code',
      scope: 'openid',
      redirectUri: window.location.origin + URLs.TeamsAuthEnd,
      nonce: uuidv4(),
    };

    const url = `https://login.microsoftonline.com/common/oauth2/authorize?`;
    const params = new URLSearchParams(queryParams).toString();
    const authorizeEndpoint = url + params;

    // Redirect to the Azure authorization endpoint. When that flow completes, the user will be directed to auth-end
    // Go to ClosePopup.tsx
    window.location.assign(authorizeEndpoint);
  }

  public render() {
    return (
      <div>
        <h1>Redirecting to consent page...</h1>
      </div>
    );
  }
}

export default ConsentPopup;
